import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import App from 'internal/components/App';
import store, { persistor } from 'internal/store';

import * as serviceWorker from 'serviceWorker';
import 'index.css';
import './internal/i18n';
import LoadingProvider from './context/LoadingContext';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <LoadingProvider>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </LoadingProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
